export default "/_next/static/images/7edc0d882f9274a304ac8c682b294ee7.png";